export default __webpack_public_path__ + "static/media/veronika.71f58cce.jpeg";